import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './media.module.less';
import { SectionTitle } from '../typography/Heading';
import Image from '../image/Image';

const Media = ({ className, children, image, alt, title }) => (
    <article className={classNames(styles.media, className)}>
        {image ? (
            <Image src={image} alt={alt ? alt : ''} role={!alt ? 'presentation' : ''} className={styles.image} />
        ) : null}
        <SectionTitle>{title}</SectionTitle>
        <div className={styles.body}>{children}</div>
    </article>
);

Media.propTypes = {
    title: PropTypes.string.isRequired,
    alt: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    image: PropTypes.string,
};

export default Media;
